import React, { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CatalogProcedure from "./CatalogProcedure";
import ServiceProcedure from "./ServiceProcedure";

const ProcedurePage = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box>
      <Tabs value={tab} onChange={handleTabChange}>
        <Tab label="Catalog" />
        <Tab label="Services" />
      </Tabs>
      {tab === 0 && (
        <Box>
          <CatalogProcedure />
        </Box>
      )}
      {tab === 1 && <ServiceProcedure />}
    </Box>
  );
};

export default ProcedurePage;
